webpackJsonp([11],{

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(223)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(250),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5ca10e3f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ImageFrame',
    props: ['url']
});

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(99)(true);
// imports


// module
exports.push([module.i, "@media only screen and (max-width:768px){iframe[data-v-44d2b8da]{width:85vw}}iframe[data-v-44d2b8da]{width:100%}", "", {"version":3,"sources":["/opt/build/repo/cowork-panel/src/components/ImageFrame.vue"],"names":[],"mappings":"AACA,yCACA,wBACI,UAAY,CACf,CACA,AACD,wBACE,UAAY,CACb","file":"ImageFrame.vue","sourcesContent":["\n@media only screen and (max-width: 768px) {\niframe[data-v-44d2b8da] {\n    width: 85vw;\n}\n}\niframe[data-v-44d2b8da] {\n  width: 100%;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(128);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(100)("63c760ff", content, true, {});

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(129)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(131),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-44d2b8da",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 131:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "rel": "dns-prefetch",
      "src": this.url,
      "loading": "lazy",
      "title": "coworking bratislava 360",
      "height": "500",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImageFrame__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImageFrame___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ImageFrame__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ImageFrame: __WEBPACK_IMPORTED_MODULE_0__ImageFrame___default.a
  },
  name: 'Calendar',
  metaInfo: {
    title: 'Calendar of Events & Meeting room'
  }
});

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(99)(true);
// imports


// module
exports.push([module.i, "h1[data-v-5ca10e3f]{color:hotpink;font-size:48px}a[data-v-5ca10e3f]{color:hotpink;text-decoration:underline}.button.is-black.is-block.is-large.meeting[data-v-5ca10e3f]{background-image:-webkit-gradient(linear,left bottom,right top,from(#b60cf6),color-stop(#9316e5),color-stop(#711ad4),color-stop(#4c1ac1),to(#1e19ae));background-image:-webkit-linear-gradient(left bottom,#b60cf6,#9316e5,#711ad4,#4c1ac1,#1e19ae);background-image:-o-linear-gradient(left bottom,#b60cf6,#9316e5,#711ad4,#4c1ac1,#1e19ae);background-image:linear-gradient(to right top,#b60cf6,#9316e5,#711ad4,#4c1ac1,#1e19ae)}iframe[data-v-5ca10e3f]{width:100%}", "", {"version":3,"sources":["/opt/build/repo/cowork-panel/src/components/Calendar.vue"],"names":[],"mappings":"AACA,oBACE,cAAe,AACf,cAAgB,CACjB,AACD,mBACE,cAAe,AACf,yBAA2B,CAC5B,AACD,4DACE,sJAA8J,AAC9J,8FAAoG,AACpG,yFAA+F,AAC/F,sFAA6F,CAC9F,AACD,wBACE,UAAY,CACb","file":"Calendar.vue","sourcesContent":["\nh1[data-v-5ca10e3f] {\n  color: hotpink;\n  font-size: 48px;\n}\na[data-v-5ca10e3f] {\n  color: hotpink;\n  text-decoration: underline;\n}\n.button.is-black.is-block.is-large.meeting[data-v-5ca10e3f] {\n  background-image: -webkit-gradient(linear, left bottom, right top, from(#b60cf6), color-stop(#9316e5), color-stop(#711ad4), color-stop(#4c1ac1), to(#1e19ae));\n  background-image: -webkit-linear-gradient(left bottom, #b60cf6, #9316e5, #711ad4, #4c1ac1, #1e19ae);\n  background-image: -o-linear-gradient(left bottom, #b60cf6, #9316e5, #711ad4, #4c1ac1, #1e19ae);\n  background-image: linear-gradient(to right top, #b60cf6, #9316e5, #711ad4, #4c1ac1, #1e19ae);\n}\niframe[data-v-5ca10e3f] {\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(199);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(100)("3de97cbc", content, true, {});

/***/ }),

/***/ 250:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Calendar"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('h1', [_c('router-link', {
    attrs: {
      "to": "/rent-a-space"
    }
  }, [_vm._v("Venue Event Space")]), _vm._v(" -\n      "), _c('a', {
    attrs: {
      "href": "mailto:info@progressbar.sk?subject=I want to book Progressbar Event Space!"
    }
  }, [_vm._v("Book Event Space")])], 1), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://calendar.google.com/calendar/embed?src=progressbar.sk_3835313939343335353737%40resource.calendar.google.com&ctz=Europe%2FPrague&showTitle=0&wkst=2&showPrint=0&showCalendars=0",
      "loading": "lazy",
      "width": "800",
      "height": "600",
      "frameborder": "0",
      "scrolling": "no"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('h1', [_c('router-link', {
    attrs: {
      "to": "rent-meeting-room-coworking-bratislava"
    }
  }, [_vm._v("\n          Meeting Room")]), _vm._v(" -\n        "), _c('a', {
    attrs: {
      "href": "mailto:info@progressbar.sk?subject=I want to book Progressbar Meeting Room!"
    }
  }, [_vm._v("Book meeting room")])], 1), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://calendar.google.com/calendar/embed?src=progressbar.sk_3238323439303131393037%40resource.calendar.google.com&ctz=Europe%2FPrague&showTitle=0&wkst=2&showPrint=0&showCalendars=0&mode=WEEK",
      "loading": "lazy",
      "width": "800",
      "height": "600",
      "frameborder": "0",
      "scrolling": "no"
    }
  })])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('h1', [_vm._v("Boxik Room")]), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://calendar.google.com/calendar/embed?src=progressbar.sk_32303436333937303934%40resource.calendar.google.com&ctz=Europe%2FPrague&showTitle=0&wkst=2&showPrint=0&showCalendars=0&mode=WEEK",
      "loading": "lazy",
      "width": "800",
      "height": "600",
      "frameborder": "0",
      "scrolling": "no"
    }
  })])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/11.b86975762993472a21ce.js